// LebonLux Categories - Unified with Leboncoin + Art
// Real Estate has 3-level hierarchy: Category -> Property Type -> Transaction Type

export const CATEGORIES = [
  {
    id: 'vehicules',
    name: 'Véhicules',
    nameEn: 'Vehicles',
    nameDe: 'Fahrzeuge',
    nameLb: 'Gefierter',
    icon: 'Car',
    color: 'red',
    subcategories: [
      { id: 'voitures', name: 'Voitures', nameEn: 'Cars', nameDe: 'Autos', nameLb: 'Autoen' },
      { id: 'motos', name: 'Motos', nameEn: 'Motorcycles', nameDe: 'Motorräder', nameLb: 'Motorrieder' },
      { id: 'caravaning', name: 'Caravaning', nameEn: 'Caravans', nameDe: 'Wohnmobile', nameLb: 'Wunnmobilen' },
      { id: 'utilitaires', name: 'Utilitaires', nameEn: 'Utility Vehicles', nameDe: 'Nutzfahrzeuge', nameLb: 'Notzgefierter' },
      { id: 'camions', name: 'Camions', nameEn: 'Trucks', nameDe: 'LKW', nameLb: 'Camionen' },
      { id: 'nautisme', name: 'Nautisme', nameEn: 'Boats', nameDe: 'Boote', nameLb: 'Booter' },
      { id: 'equipement-auto', name: 'Équipement auto', nameEn: 'Car Equipment', nameDe: 'Autozubehör', nameLb: 'Autozubehéier' },
      { id: 'equipement-moto', name: 'Équipement moto', nameEn: 'Motorcycle Equipment', nameDe: 'Motorradzubehör', nameLb: 'Motorriedzubehéier' }
    ]
  },
  {
    id: 'immobilier',
    name: 'Immobilier',
    nameEn: 'Real Estate',
    nameDe: 'Immobilien',
    nameLb: 'Immobilien',
    icon: 'Home',
    color: 'emerald',
    hasThirdLevel: true, // Flag to indicate 3-level hierarchy
    subcategories: [
      { 
        id: 'appartement', 
        name: 'Appartement', 
        nameEn: 'Apartment',
        nameDe: 'Wohnung',
        nameLb: 'Appartement',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' },
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      },
      { 
        id: 'maison', 
        name: 'Maison', 
        nameEn: 'House',
        nameDe: 'Haus',
        nameLb: 'Haus',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' },
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      },
      { 
        id: 'terrain', 
        name: 'Terrain', 
        nameEn: 'Land',
        nameDe: 'Grundstück',
        nameLb: 'Terrain',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' }
        ]
      },
      { 
        id: 'parking-garage', 
        name: 'Parking / Garage', 
        nameEn: 'Parking / Garage',
        nameDe: 'Parkplatz / Garage',
        nameLb: 'Parking / Garage',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' },
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      },
      { 
        id: 'bureau-commerce', 
        name: 'Bureau / Commerce', 
        nameEn: 'Office / Shop',
        nameDe: 'Büro / Geschäft',
        nameLb: 'Büro / Geschäft',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' },
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      },
      { 
        id: 'immeuble', 
        name: 'Immeuble', 
        nameEn: 'Building',
        nameDe: 'Gebäude',
        nameLb: 'Gebai',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' }
        ]
      },
      { 
        id: 'loft-atelier', 
        name: 'Loft / Atelier', 
        nameEn: 'Loft / Studio',
        nameDe: 'Loft / Atelier',
        nameLb: 'Loft / Atelier',
        transactionTypes: [
          { id: 'sale', name: 'À vendre', nameEn: 'For Sale', nameDe: 'Zu verkaufen', nameLb: 'Ze verkafen' },
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      },
      { 
        id: 'colocation', 
        name: 'Colocation', 
        nameEn: 'Roommate / Shared',
        nameDe: 'WG-Zimmer',
        nameLb: 'WG-Zëmmer',
        transactionTypes: [
          { id: 'rent', name: 'À louer', nameEn: 'For Rent', nameDe: 'Zu vermieten', nameLb: 'Ze lounen' }
        ]
      }
    ]
  },
  {
    id: 'vacances',
    name: 'Locations de vacances',
    nameEn: 'Vacation Rentals',
    nameDe: 'Ferienwohnungen',
    nameLb: 'Vakanzleiungen',
    icon: 'Palmtree',
    color: 'cyan',
    allowWorldwide: true, // Special flag: allows listings from anywhere in the world
    hasThirdLevel: false, // No transaction type selection (always rental)
    subcategories: [
      { id: 'appartement-vacances', name: 'Appartement', nameEn: 'Apartment', nameDe: 'Wohnung', nameLb: 'Appartement' },
      { id: 'maison-vacances', name: 'Maison / Villa', nameEn: 'House / Villa', nameDe: 'Haus / Villa', nameLb: 'Haus / Villa' },
      { id: 'chalet', name: 'Chalet / Cabin', nameEn: 'Chalet / Cabin', nameDe: 'Chalet / Hütte', nameLb: 'Chalet / Hütt' },
      { id: 'chambre-hote', name: "Chambre d'hôtes", nameEn: 'Guest Room / B&B', nameDe: 'Gästezimmer', nameLb: 'Gaaschtezëmmer' },
      { id: 'gite', name: 'Gîte', nameEn: 'Cottage / Gîte', nameDe: 'Ferienhaus', nameLb: 'Vakanzhaus' },
      { id: 'camping', name: 'Camping / Glamping', nameEn: 'Camping / Glamping', nameDe: 'Camping / Glamping', nameLb: 'Camping / Glamping' },
      { id: 'insolite', name: 'Hébergement insolite', nameEn: 'Unique Stays', nameDe: 'Außergewöhnliche Unterkünfte', nameLb: 'Ongewéinlech Ënnerkënft' }
    ]
  },
  {
    id: 'mode',
    name: 'Mode',
    nameEn: 'Fashion',
    nameDe: 'Mode',
    nameLb: 'Moud',
    icon: 'Shirt',
    color: 'pink',
    subcategories: [
      { id: 'vetements-femme', name: 'Vêtements femme', nameEn: "Women's Clothing", nameDe: 'Damenkleidung', nameLb: 'Damekleeder' },
      { id: 'vetements-homme', name: 'Vêtements homme', nameEn: "Men's Clothing", nameDe: 'Herrenkleidung', nameLb: 'Härekleeder' },
      { id: 'chaussures', name: 'Chaussures', nameEn: 'Shoes', nameDe: 'Schuhe', nameLb: 'Schong' },
      { id: 'montres-bijoux', name: 'Montres & Bijoux', nameEn: 'Watches & Jewelry', nameDe: 'Uhren & Schmuck', nameLb: 'Auer & Bijou' },
      { id: 'accessoires-bagagerie', name: 'Accessoires & Bagagerie', nameEn: 'Accessories & Bags', nameDe: 'Accessoires & Taschen', nameLb: 'Accessoiren & Täschen' },
      { id: 'vetements-bebe', name: 'Vêtements bébé', nameEn: 'Baby Clothes', nameDe: 'Babykleidung', nameLb: 'Babykleeder' }
    ]
  },
  {
    id: 'maison-jardin',
    name: 'Maison & Jardin',
    nameEn: 'Home & Garden',
    nameDe: 'Haus & Garten',
    nameLb: 'Haus & Gaart',
    icon: 'Sofa',
    color: 'amber',
    subcategories: [
      { id: 'ameublement', name: 'Ameublement', nameEn: 'Furniture', nameDe: 'Möbel', nameLb: 'Miwwelen' },
      { id: 'electromenager', name: 'Électroménager', nameEn: 'Appliances', nameDe: 'Haushaltsgeräte', nameLb: 'Haushaltsgeräter' },
      { id: 'arts-table', name: 'Arts de la table', nameEn: 'Tableware', nameDe: 'Geschirr', nameLb: 'Geschier' },
      { id: 'decoration', name: 'Décoration', nameEn: 'Decoration', nameDe: 'Dekoration', nameLb: 'Dekoratioun' },
      { id: 'linge-maison', name: 'Linge de maison', nameEn: 'Household Linen', nameDe: 'Heimtextilien', nameLb: 'Haushaltstextilien' },
      { id: 'bricolage', name: 'Bricolage', nameEn: 'DIY', nameDe: 'Heimwerken', nameLb: 'Bricolage' },
      { id: 'jardin-plantes', name: 'Jardin & Plantes', nameEn: 'Garden & Plants', nameDe: 'Garten & Pflanzen', nameLb: 'Gaart & Planzen' }
    ]
  },
  {
    id: 'famille',
    name: 'Famille',
    nameEn: 'Family',
    nameDe: 'Familie',
    nameLb: 'Famill',
    icon: 'Baby',
    color: 'rose',
    subcategories: [
      { id: 'equipement-bebe', name: 'Équipement bébé', nameEn: 'Baby Equipment', nameDe: 'Babyausstattung', nameLb: 'Babyausrüstung' },
      { id: 'mobilier-enfant', name: 'Mobilier enfant', nameEn: "Children's Furniture", nameDe: 'Kindermöbel', nameLb: 'Kannermiwwelen' },
      { id: 'jeux-jouets', name: 'Jeux & Jouets', nameEn: 'Toys & Games', nameDe: 'Spielzeug', nameLb: 'Spillsaachen' },
      { id: 'vetements-enfants', name: 'Vêtements enfants', nameEn: "Children's Clothing", nameDe: 'Kinderkleidung', nameLb: 'Kannerkleeder' }
    ]
  },
  {
    id: 'electronique',
    name: 'Électronique',
    nameEn: 'Electronics',
    nameDe: 'Elektronik',
    nameLb: 'Elektronik',
    icon: 'Smartphone',
    color: 'slate',
    subcategories: [
      { id: 'informatique', name: 'Informatique', nameEn: 'Computers', nameDe: 'Computer', nameLb: 'Computeren' },
      { id: 'telephones', name: 'Téléphones', nameEn: 'Phones', nameDe: 'Handys', nameLb: 'Telefonen' },
      { id: 'image-son', name: 'Image & Son', nameEn: 'Audio & Video', nameDe: 'Audio & Video', nameLb: 'Audio & Video' },
      { id: 'consoles-jeux-video', name: 'Consoles & Jeux vidéo', nameEn: 'Gaming', nameDe: 'Gaming', nameLb: 'Gaming' },
      { id: 'accessoires-informatique', name: 'Accessoires informatique', nameEn: 'Computer Accessories', nameDe: 'PC-Zubehör', nameLb: 'Computerzubehéier' }
    ]
  },
  {
    id: 'loisirs',
    name: 'Loisirs',
    nameEn: 'Leisure',
    nameDe: 'Freizeit',
    nameLb: 'Fräizäit',
    icon: 'Gamepad2',
    color: 'violet',
    subcategories: [
      { id: 'dvd-films', name: 'DVD - Films', nameEn: 'DVDs & Movies', nameDe: 'DVDs & Filme', nameLb: 'DVDen & Filmer' },
      { id: 'cd-musique', name: 'CD - Musique', nameEn: 'CDs & Music', nameDe: 'CDs & Musik', nameLb: 'CDen & Musek' },
      { id: 'livres', name: 'Livres', nameEn: 'Books', nameDe: 'Bücher', nameLb: 'Bicher' },
      { id: 'animaux', name: 'Animaux', nameEn: 'Animals', nameDe: 'Tiere', nameLb: 'Déieren' },
      { id: 'velos', name: 'Vélos', nameEn: 'Bicycles', nameDe: 'Fahrräder', nameLb: 'Vëloen' },
      { id: 'sports-plein-air', name: 'Sports & Plein air', nameEn: 'Sports & Outdoors', nameDe: 'Sport & Outdoor', nameLb: 'Sport & Outdoor' },
      { id: 'instruments-musique', name: 'Instruments de musique', nameEn: 'Musical Instruments', nameDe: 'Musikinstrumente', nameLb: 'Museksinstrumenter' },
      { id: 'collection', name: 'Collection', nameEn: 'Collectibles', nameDe: 'Sammeln', nameLb: 'Sammelen' },
      { id: 'jeux-societe', name: 'Jeux de société', nameEn: 'Board Games', nameDe: 'Brettspiele', nameLb: 'Brietspiller' },
      { id: 'vins-gastronomie', name: 'Vins & Gastronomie', nameEn: 'Wine & Food', nameDe: 'Wein & Gourmet', nameLb: 'Wäin & Gourmet' }
    ]
  },
  {
    id: 'services',
    name: 'Services',
    nameEn: 'Services',
    nameDe: 'Dienstleistungen',
    nameLb: 'Servicer',
    icon: 'Wrench',
    color: 'orange',
    subcategories: [
      { id: 'prestations-services', name: 'Prestations de services', nameEn: 'Service Providers', nameDe: 'Dienstleister', nameLb: 'Déngschtleeschter' },
      { id: 'cours-particuliers', name: 'Cours particuliers', nameEn: 'Private Lessons', nameDe: 'Privatunterricht', nameLb: 'Privatstonnen' },
      { id: 'covoiturage', name: 'Covoiturage', nameEn: 'Carpooling', nameDe: 'Mitfahrgelegenheit', nameLb: 'Carpooling' },
      { id: 'evenements', name: 'Évènements', nameEn: 'Events', nameDe: 'Veranstaltungen', nameLb: 'Evenementer' },
      { id: 'billetterie', name: 'Billetterie', nameEn: 'Tickets', nameDe: 'Tickets', nameLb: 'Ticketen' }
    ]
  },
  {
    id: 'materiel-pro',
    name: 'Matériel professionnel',
    nameEn: 'Professional Equipment',
    nameDe: 'Profi-Ausstattung',
    nameLb: 'Profi-Ausrüstung',
    icon: 'HardHat',
    color: 'yellow',
    subcategories: [
      { id: 'materiel-agricole', name: 'Matériel agricole', nameEn: 'Agricultural Equipment', nameDe: 'Landmaschinen', nameLb: 'Landmaschinnen' },
      { id: 'transport-manutention', name: 'Transport - Manutention', nameEn: 'Transport & Handling', nameDe: 'Transport & Lager', nameLb: 'Transport & Lager' },
      { id: 'btp-chantier', name: 'BTP - Chantier', nameEn: 'Construction', nameDe: 'Bauwesen', nameLb: 'Bauwiesen' },
      { id: 'outillage-materiaux', name: 'Outillage - Matériaux', nameEn: 'Tools & Materials', nameDe: 'Werkzeug', nameLb: 'Geschir' },
      { id: 'equipements-industriels', name: 'Équipements industriels', nameEn: 'Industrial Equipment', nameDe: 'Industrieausstattung', nameLb: 'Industriausrüstung' },
      { id: 'restauration-hotellerie', name: 'Restauration - Hôtellerie', nameEn: 'Restaurant & Hotel', nameDe: 'Gastronomie', nameLb: 'Gastronomie' },
      { id: 'fournitures-bureau', name: 'Fournitures de bureau', nameEn: 'Office Supplies', nameDe: 'Bürobedarf', nameLb: 'Bürobedarf' },
      { id: 'commerces-marches', name: 'Commerces & Marchés', nameEn: 'Shops & Markets', nameDe: 'Handel', nameLb: 'Handel' },
      { id: 'materiel-medical', name: 'Matériel médical', nameEn: 'Medical Equipment', nameDe: 'Medizintechnik', nameLb: 'Medezintechnik' }
    ]
  },
  {
    id: 'art',
    name: 'Art',
    nameEn: 'Art',
    nameDe: 'Kunst',
    nameLb: 'Konscht',
    icon: 'Palette',
    color: 'purple',
    subcategories: [
      { id: 'peinture', name: 'Peinture', nameEn: 'Painting', nameDe: 'Malerei', nameLb: 'Molerei' },
      { id: 'photographie', name: 'Photographie', nameEn: 'Photography', nameDe: 'Fotografie', nameLb: 'Fotografie' },
      { id: 'sculpture', name: 'Sculpture', nameEn: 'Sculpture', nameDe: 'Skulptur', nameLb: 'Skulptur' },
      { id: 'dessin', name: 'Dessin', nameEn: 'Drawing', nameDe: 'Zeichnung', nameLb: 'Zeechnung' },
      { id: 'gravure', name: 'Gravure & Estampe', nameEn: 'Printmaking', nameDe: 'Druckgrafik', nameLb: 'Dréckgrafik' },
      { id: 'art-numerique', name: 'Art numérique', nameEn: 'Digital Art', nameDe: 'Digitale Kunst', nameLb: 'Digital Konscht' },
      { id: 'ceramique', name: 'Céramique', nameEn: 'Ceramics', nameDe: 'Keramik', nameLb: 'Keramik' },
      { id: 'autre-art', name: 'Autre', nameEn: 'Other', nameDe: 'Sonstiges', nameLb: 'Anerer' }
    ]
  },
  {
    id: 'autres',
    name: 'Autres',
    nameEn: 'Other',
    nameDe: 'Sonstiges',
    nameLb: 'Anerer',
    icon: 'MoreHorizontal',
    color: 'gray',
    subcategories: [
      { id: 'autres-divers', name: 'Divers', nameEn: 'Miscellaneous', nameDe: 'Verschiedenes', nameLb: 'Verschiddenes' }
    ]
  }
];

// Helper to get category by ID
export const getCategoryById = (id) => {
  return CATEGORIES.find(cat => cat.id === id);
};

// Helper to get subcategory by ID
export const getSubcategoryById = (categoryId, subcategoryId) => {
  const category = getCategoryById(categoryId);
  if (!category) return null;
  return category.subcategories.find(sub => sub.id === subcategoryId);
};

// Get localized name based on language
export const getLocalizedName = (item, language = 'fr') => {
  if (!item) return '';
  if (language === 'en' && item.nameEn) return item.nameEn;
  if (language === 'de' && item.nameDe) return item.nameDe;
  if (language === 'lb' && item.nameLb) return item.nameLb;
  return item.name; // Default to French
};

// Helper to flatten all categories and subcategories
export const getFlatCategories = () => {
  const flat = [];
  CATEGORIES.forEach(cat => {
    flat.push({ id: cat.id, name: cat.name, nameEn: cat.nameEn, type: 'category' });
    cat.subcategories.forEach(sub => {
      flat.push({ id: sub.id, name: sub.name, nameEn: sub.nameEn, type: 'subcategory', parentId: cat.id });
    });
  });
  return flat;
};

// Get transaction types for a real estate subcategory
export const getTransactionTypes = (subcategoryId, language = 'fr') => {
  const realEstate = getCategoryById('immobilier');
  if (!realEstate) return [];
  
  const subcategory = realEstate.subcategories.find(sub => sub.id === subcategoryId);
  if (!subcategory || !subcategory.transactionTypes) return [];
  
  return subcategory.transactionTypes.map(tt => ({
    ...tt,
    label: getLocalizedName(tt, language)
  }));
};

export default CATEGORIES;
